import { useMissionsTranslation } from '../../../../ui/hooks';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { Box, List, ListItem, Typography } from '@mui/material';
import { green } from '@mui/material/colors';
import React from 'react';
import { getPositionCount } from '../utils/getPositionCount';
import { ShiftDetailCard } from './ShiftDetailCard';
import { ShiftPositionName } from './ShiftPositionName';
export const ShiftPositionsCard = ({ shiftId, shiftPositions, shiftPositionsOverride, displayNumberOfPositions, allowMissionChange, approvedRequests, }) => {
    const { t } = useMissionsTranslation();
    if (!shiftPositions && !shiftPositionsOverride) {
        return null;
    }
    const shiftPositionsData = shiftPositionsOverride
        ? shiftPositionsOverride
        : shiftPositions === null || shiftPositions === void 0 ? void 0 : shiftPositions.map((position) => ({
            id: position.id,
            name: position.data.name,
            quantity: position.quantity,
            positionCount: getPositionCount(approvedRequests, position.id),
        }));
    return (React.createElement(ShiftDetailCard, { title: t('missions.missionDetails.positionsNeeded') },
        React.createElement(List, { sx: { display: 'flex', flexDirection: 'column' }, "data-test": 'shift-positions-card' }, shiftPositionsData === null || shiftPositionsData === void 0 ? void 0 : shiftPositionsData.map((positionData) => (React.createElement(ListItem, { key: positionData.id, dense: true, sx: {
                display: 'flex',
                justifyContent: 'space-between',
                columnGap: { sm: 3 },
                flexWrap: { xs: 'wrap', sm: 'noWrap' },
                px: 0,
            } },
            React.createElement(ShiftPositionName, { shiftId: shiftId, positionId: positionData.id, positionName: positionData.name, allowMissionChange: allowMissionChange }),
            (allowMissionChange || displayNumberOfPositions) && (React.createElement(Box, { sx: {
                    display: 'flex',
                    columnGap: 0.5,
                    justifyContent: 'flex-end',
                    flexBasis: { xs: '40%', sm: '20%' },
                    alignSelf: 'flex-start',
                }, "data-test": 'quantity' },
                getPositionCount(approvedRequests, positionData.id) === positionData.quantity && (React.createElement(Typography, { variant: 'body2', sx: { display: 'flex', alignItems: 'center' } },
                    React.createElement(CheckCircleIcon, { fontSize: 'inherit', sx: { color: green[500] } }))),
                React.createElement(Typography, { variant: 'body2' }, `${positionData.positionCount}/${positionData.quantity}`)))))))));
};
